/* eslint-disable camelcase */
import * as ApiBase from '../../APIBase'
import { updateOrders, updateOrderStatus, updatePagination } from './index'
import { ClickedOntrack as GA_ClickedOntrack } from '../../Analytics/googleAnalytics'
import { ClickedOntrack as FB_ClickedOntrack } from '../../Analytics/facebook'

export const fetchOrders = (page = 1, perPage = 8) => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name
    ? getState().merchant.canonical_name : ''
  const url = `/${merchantCanonicalName}/customer/orders`
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''
  const orders = await ApiBase.get(url, {
    currentPage: page,
    perPage,
    status: '',
    region: '',
  }, accessToken)
  dispatch(updateOrders(orders.rows))
  dispatch(updatePagination(orders.pagination))
  return orders
}

export const fetchOrderStatus = (orderID) => async (dispatch, getState) => {
  const merchantCanonicalName = getState().merchant.canonical_name
    ? getState().merchant.canonical_name : ''

  GA_ClickedOntrack(orderID)
  FB_ClickedOntrack(orderID)

  const url = `/${merchantCanonicalName}/customer/order_status`
  const accessToken = getState().user.accessToken ? getState().user.accessToken : ''

  const orderStatus = await ApiBase.get(url, {
    order_code: orderID,
  }, accessToken)

  dispatch(updateOrderStatus(orderStatus.result))

  return true
}
